import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ar', name: 'العربية', flag: '🇹🇳' }
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="relative group">
      <button className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-sonarges-gray-100 dark:bg-sonarges-gray-700 hover:bg-sonarges-gray-200 dark:hover:bg-sonarges-gray-600 transition-all duration-200">
        <span className="text-xl">
          {languages.find(lang => lang.code === i18n.language)?.flag || '🌐'}
        </span>
        <span className="text-sm font-medium text-sonarges-gray-700 dark:text-sonarges-gray-300">
          {languages.find(lang => lang.code === i18n.language)?.code.toUpperCase() || 'FR'}
        </span>
        <svg className="w-4 h-4 text-sonarges-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-sonarges-gray-800 rounded-lg shadow-xl border border-sonarges-gray-200 dark:border-sonarges-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`w-full flex items-center space-x-3 px-4 py-3 hover:bg-sonarges-gray-100 dark:hover:bg-sonarges-gray-700 transition-colors first:rounded-t-lg last:rounded-b-lg ${
              i18n.language === lang.code ? 'bg-sonarges-green-50 dark:bg-sonarges-green-900/20' : ''
            }`}
          >
            <span className="text-2xl">{lang.flag}</span>
            <span className="text-sm font-medium text-sonarges-gray-900 dark:text-white">
              {lang.name}
            </span>
            {i18n.language === lang.code && (
              <svg className="w-5 h-5 text-sonarges-green-600 dark:text-sonarges-green-400 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
